import React, { useState, useEffect } from "react";

const roasts = [
    { emoji: "🫠", line: "This paste melted into the void.", sub: "Gone. Reduced to atoms." },
    { emoji: "💀", line: "Paste not found. Just like your motivation.", sub: "We both know you should be working right now." },
    { emoji: "🕳️", line: "You fell into a digital pothole.", sub: "The URL lied to you. It does that sometimes." },
    { emoji: "🤡", line: "Congrats, you broke the internet.", sub: "Just kidding. But this link is definitely broken." },
    { emoji: "👻", line: "This paste ghosted you.", sub: "It didn't even leave a note. Rude." },
    { emoji: "🦕", line: "This paste went extinct.", sub: "Last seen in the Cretaceous period." },
    { emoji: "🧊", line: "This link is colder than your ex.", sub: "Dead. Frozen. Not coming back." },
    { emoji: "🪦", line: "Here lies a paste that once was.", sub: "Press F to pay respects." },
    { emoji: "🍕", line: "404: Paste eaten. Sorry.", sub: "We were hungry. The bytes looked delicious." },
    { emoji: "🐒", line: "A monkey unplugged the server.", sub: "Actually no, this paste just doesn't exist." },
    { emoji: "🛸", line: "Aliens abducted your paste.", sub: "They said the code was 'mid' and left." },
    { emoji: "🧻", line: "This paste has been wiped.", sub: "Nothing left. Not even the memories." },
    { emoji: "🎪", line: "Welcome to the 404 circus.", sub: "You're the main act. The URL was the joke." },
    { emoji: "🦴", line: "You dug up nothing.", sub: "This paste is deader than Latin." },
    { emoji: "🔮", line: "The crystal ball says… nope.", sub: "No paste here. Try manifesting harder." },
    { emoji: "🧃", line: "Juice expired. Paste gone.", sub: "You squeezed a link that had nothing left." },
    { emoji: "🫥", line: "This paste is in witness protection.", sub: "New identity. New URL. You'll never find it." },
    { emoji: "🐸", line: "It's not easy being 404.", sub: "— Kermit, probably" },
    { emoji: "🪤", line: "It's a trap! And also a dead link.", sub: "Admiral Ackbar tried to warn you." },
    { emoji: "🌚", line: "The dark side has no paste for you.", sub: "Only emptiness. And this sick 404 page." },
];

function pickRandom() {
    return roasts[Math.floor(Math.random() * roasts.length)];
}

const Error404 = () => {
    const [roast, setRoast] = useState(pickRandom);
    const [spin, setSpin] = useState(false);

    useEffect(() => {
        setSpin(true);
        const t = setTimeout(() => setSpin(false), 500);
        return () => clearTimeout(t);
    }, [roast]);

    const reroll = () => {
        let next;
        do { next = pickRandom(); } while (next.line === roast.line);
        setRoast(next);
    };

    return (
        <div className="error-container">
            <div
                className="error-emoji"
                style={{
                    fontSize: 64,
                    transition: "transform 0.5s cubic-bezier(.36,1.4,.5,1)",
                    transform: spin ? "rotateY(360deg) scale(1.1)" : "rotateY(0deg) scale(1)",
                    cursor: "pointer",
                    userSelect: "none",
                }}
                onClick={reroll}
                title="Click for another roast"
            >
                {roast.emoji}
            </div>
            <div className="error-code">404</div>
            <div className="error-message" style={{ color: "#808080", fontSize: 15, fontWeight: 500 }}>
                {roast.line}
            </div>
            <div className="error-message" style={{ color: "#404040", fontSize: 12, marginTop: 2 }}>
                {roast.sub}
            </div>
            <div style={{ display: "flex", gap: 12, marginTop: 24, alignItems: "center" }}>
                <a href="/" className="error-link">Create a new paste</a>
                <button
                    className="error-link"
                    onClick={reroll}
                    style={{ background: "transparent", cursor: "pointer" }}
                >
                    Roast me again
                </button>
            </div>
        </div>
    );
};

export default Error404;
